import { IEmployee } from "../../models/interfaces/employees";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const DEFAULT_STATE = [];

const initialState: IEmployee[] = (() => {
  const persistedState = localStorage.getItem("__redux__state__");
  return persistedState ? JSON.parse(persistedState).users : DEFAULT_STATE;
})();

export const employeesSlice = createSlice({
  name: "listEmployees",
  initialState,
  reducers: {
    updateEmployees: (state, action: PayloadAction<IEmployee[]>) => {
      return action.payload;
    },
    addEmployee: (state, action: PayloadAction<IEmployee>) => {
      state.unshift(action.payload);
    },
    addMultipleEmployees: (state, action: PayloadAction<IEmployee[]>) => {
      // Agregar múltiples empleados al inicio de la lista sin reemplazar
      action.payload.forEach((employee) => {
        state.unshift(employee);
      });
    },
    modifyEmployee: (state, action: PayloadAction<IEmployee>) => {
      const employeeIndex = state.findIndex(
        (employee) => employee.idEmployee === action.payload.idEmployee
      );

      if (employeeIndex !== -1) {
        // Mantener el positionName existente si no viene en el payload
        const currentEmployee = state[employeeIndex];
        state[employeeIndex] = {
          ...action.payload,
          positionName:
            action.payload.positionName || currentEmployee.positionName,
          idRol: action.payload.idRol || currentEmployee.idRol,
        };
      }
    },
    deleteEmployee: (state, action: PayloadAction<number>) => {
      const employeeIndex = state.findIndex(
        (employee) => employee.idEmployee === action.payload
      );
      state.splice(employeeIndex, 1);
    },
  },
});

export default employeesSlice.reducer;
export const {
  updateEmployees,
  addEmployee,
  addMultipleEmployees,
  modifyEmployee,
  deleteEmployee,
} = employeesSlice.actions;
